// ------------------------------------------
// imgタグに「js-color-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// 画面内に完全に表示されたらカラーになる。それ以外は白黒。
// ------------------------------------------
class ColorParallax {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);

    para_ele.forEach((ele, index) => {
      let property, scrub;

      $(ele).css({
        "object-fit": "cover",
        "object-position": "50% 0%",
        width: "100%",
        height: "100%",
        filter: "grayscale(100%)", // 初期は白黒
        transition: "filter 0.5s ease",
      });

      property = "50% 100%";
      scrub = $(ele).data("scrub") ? $(ele).data("scrub") : 3;

      ele.classList.add(cls + index);

      // パララックス
      gsap.to("." + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: "." + cls + index,
          start: "top bottom",
          end: "bottom top",
          scrub: scrub,
        },
      });

      // 白黒 → カラー制御
      gsap.to(ele, {
        filter: "grayscale(0%)",
        scrollTrigger: {
          trigger: ele,
          start: "bottom bottom",
          end: "top top",
          toggleActions: "play reverse play reverse",
        },
      });
    });
  }
}

